import ApiClient from './ApiClient';

class CampaignDetailsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  detailsUrl(campaignId) {
    return `${this.url}/${campaignId}/campaign_details`;
  }

  index({ campaignId, params = {} }) {
    return axios.get(this.detailsUrl(campaignId), { params });
  }

  bulkTag({ campaignId, payload }) {
    return axios.post(`${this.detailsUrl(campaignId)}/bulk_tag`, payload);
  }

  bulkResend({ campaignId, payload }) {
    return axios.post(`${this.detailsUrl(campaignId)}/bulk_resend`, payload);
  }

  export({ campaignId, params = {} }) {
    return axios.get(`${this.detailsUrl(campaignId)}/export`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new CampaignDetailsAPI();
